import React, { useState } from "react";
import { ResponsivePie } from "@nivo/pie";

export const AtRiskSuspendedPharmacyPie = ({
  eligiblePharmacyCount,
  atRiskPharmacyCount,
  suspendedPharmacyCount,
}) => {
  return (
    <ResponsivePie
      data={[
        {
          id: "eligible",
          label: "Eligible",
          value: eligiblePharmacyCount,
          color: "#24b668",
        },
        {
          id: "at_risk",
          label: "At Risk",
          value: atRiskPharmacyCount,
          color: "#ff681f",
        },
        {
          id: "suspended",
          label: "Suspended",
          value: suspendedPharmacyCount,
          color: "#e91e63",
        },
      ]}
      margin={{ top: 20, right: 5, bottom: 40, left: 5 }}
      innerRadius={0.7}
      padAngle={0.7}
      cornerRadius={3}
      activeOuterRadiusOffset={8}
      colors={{ datum: "data.color" }}
      layers={["arcs", "legends"]}
      legends={[
        {
          anchor: "bottom",
          direction: "row",
          justify: false,
          translateX: 0,
          translateY: 36,
          itemsSpacing: 5,
          itemWidth: 65,
          itemHeight: 18,
          itemTextColor: "#999",
          itemDirection: "left-to-right",
          itemOpacity: 1,
          symbolSize: 15,
          symbolShape: "circle",
        },
      ]}
    />
  );
};
